import React, { useState, useRef } from "react";
import "./OtpInput.css";

function OtpInput({ length = 6, onChangeOtp }) {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputsRef = useRef([]);

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/g, ""); // only digits
    const newOtp = [...otp];
    newOtp[index] = value ? value[0] : "";
    setOtp(newOtp);

    // Move focus to next input if digit entered
    if (value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }

    onChangeOtp(newOtp.join(""));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        // If current box has value → clear it
        newOtp[index] = "";
        setOtp(newOtp);
        onChangeOtp(newOtp.join(""));
      } else if (index > 0) {
        // If current box empty → move focus back and clear prev
        inputsRef.current[index - 1].focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
        onChangeOtp(newOtp.join(""));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, ""); // only digits
    if (!pasted) return;

    const newOtp = [...otp];
    for (let i = 0; i < length; i++) {
      newOtp[i] = pasted[i] || "";
    }
    setOtp(newOtp);
    onChangeOtp(newOtp.join(""));

    // Move focus to last filled box
    const lastIndex = Math.min(pasted.length, length) - 1;
    if (lastIndex >= 0) {
      inputsRef.current[lastIndex].focus();
    }
  };

  return (
    <div className="otp-boxes">
      {otp.map((data, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={otp[index]}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={index === 0 ? handlePaste : undefined} // handle paste only on first input
          ref={(el) => (inputsRef.current[index] = el)}
          className="otp-input"
        />
      ))}
    </div>
  );
}

export default OtpInput;
